/*
 * UI/UX改善 #7: アクセシビリティ改善
 * スキップナビゲーション - キーボードユーザーがメインコンテンツに直接ジャンプ可能
 */

export function SkipNav() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#E03030] focus:text-white focus:text-sm focus:font-bold focus:rounded focus:shadow-lg focus:outline-none"
    >
      メインコンテンツへスキップ
    </a>
  );
}
